import { render, staticRenderFns } from "./SessionIconButton.vue?vue&type=template&id=cbb2f4a6&scoped=true"
import script from "./SessionIconButton.vue?vue&type=script&lang=js"
export * from "./SessionIconButton.vue?vue&type=script&lang=js"
import style0 from "./SessionIconButton.vue?vue&type=style&index=0&id=cbb2f4a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb2f4a6",
  null
  
)

export default component.exports